import { MaybeCountryConfiguration } from '../types/api'

export const readCountryConfigFromWindow = (): MaybeCountryConfiguration => {
  const config = window.__COUNTRY_CONFIG__
  return config && 'error' in config ? undefined : config
}
